import { render, staticRenderFns } from "./addUnitPhone.vue?vue&type=template&id=ffea2ea0&scoped=true&"
import script from "./addUnitPhone.vue?vue&type=script&lang=js&"
export * from "./addUnitPhone.vue?vue&type=script&lang=js&"
import style0 from "./addUnitPhone.vue?vue&type=style&index=0&id=ffea2ea0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea2ea0",
  null
  
)

export default component.exports